import { Component, OnInit } from '@angular/core';
import { CommonNavItems, INavItem, Nav } from '../nav';
import { RestaurantInfoResolver } from 'src/app/appResolvers/restaurant-info.resolver';
import { IBasicInfo } from 'src/app/appModels/IBasicInfo';
import { IProfile } from 'src/app/appModels/IProfile';
import { HandleSubscriptionsComponent } from 'src/app/appDirectives/handle-subscriptions.directive';
import { IRole } from 'src/app/appModels/IRole';
import {
  GlobalAuthResolver,
  ProfileLoadState,
} from 'src/app/appServices/global-auth/global-auth.resolver';
import { combineLatest, fromEvent } from 'rxjs';

@Component({
    selector: 'app-tab-menu',
    templateUrl: './tab-menu.component.html',
    styleUrls: ['./tab-menu.component.scss'],
    standalone: false
})
export class TabMenuComponent extends HandleSubscriptionsComponent implements OnInit {
  current_tab = "pos" // Set this as you default page name
  public appPages: INavItem[] = [];
  basicInfo: IBasicInfo;
  role: IRole | null = null;

  constructor(
    private _basicInfoResolver: RestaurantInfoResolver,
    private _globalAuthResolver: GlobalAuthResolver
  ) {
   super();
  }

  ngOnInit() {
    this.subscribeBasicInfo();
    this.subscribeNavigationState();
    this.handleSubscription(fromEvent(window, 'online'), () => {
      if (this._globalAuthResolver.isLoggedIn()) {
        this.getProfile(true);
      }
    });
  }

  getProfile(force = false) {
    this.handleSubscription(
      this._globalAuthResolver.getProfile(force),
      () => undefined,
    );
  }

  private subscribeNavigationState(): void {
    this.handleSubscription(
      combineLatest([
        this._globalAuthResolver.loggedIn,
        this._globalAuthResolver.profile$,
        this._globalAuthResolver.profileState$,
      ]),
      ([loggedIn, profile, state]: [
        boolean,
        IProfile | null,
        ProfileLoadState,
      ]) => {
        if (!loggedIn) {
          this.role = null;
          this.appPages = [];
          return;
        }

        if (this.isKnownRole(profile?.role)) {
          this.role = profile.role;
          this.filterNavItemsByRole();
          return;
        }

        this.role = null;
        this.appPages = this.isSafeFallbackState(state)
          ? [...CommonNavItems]
          : [];

        if (state === 'idle') {
          this.getProfile();
        }
      },
    );
  }
  
   /**
   * Filters the navigation
   */
   filterNavItemsByRole() {
    if (!this.role) {
      this.appPages = [];
      return;
    }
    this.appPages = Nav.filter(item => {
      // Check user roles
      const isRoleMatch = item.roles?.includes(this.role);

      return isRoleMatch;
    });
  }

  private isKnownRole(role: string | null | undefined): role is IRole {
    return role === IRole.Admin || role === IRole.Cashier;
  }

  private isSafeFallbackState(state: ProfileLoadState): boolean {
    return state === 'idle' || state === 'loading' ||
      state === 'offline' || state === 'unavailable';
  }

  /**
   * subscribe basic info
   */
  subscribeBasicInfo() {
    this.handleSubscription(this._basicInfoResolver.restaurantBasicInfo,
      (res) => {
        this.basicInfo = res;
        // this.appPages = Nav.filter(item => !(item.businessType ?? '') || item.businessType === (this.basicInfo?.businessType ?? ''));
      }
    );
  }


  setCurrentTab(ev: any) {
    this.current_tab = ev;
  }


}
